module.exports = "<div class=\"chart-container\"></div>"